import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { Action } from 'redux';
import { UpdateUserSuccess } from '../../user/action-creators';
import { CreateConnectedAccount } from '../action-creators';
import { UPDATE_USER_SUCCESS } from '../../user/actions';
import { isAddressReady } from '@webapp/utils/user/is-address-ready';

export const createAccountAfterProfileUpdateEpic = (
  action$: Observable<Action>
) =>
  action$.pipe(
    ofType<Action, UpdateUserSuccess>(UPDATE_USER_SUCCESS),
    filter(
      (action) =>
        action.redirectFrom === 'WALLET' && isAddressReady(action.user)
    ),
    map((action) => new CreateConnectedAccount({ user_profile: action.user }))
  );
